import { Store } from 'antd/lib/form/interface';
import { ColumnsType } from 'antd/lib/table';
import { ReportKey, ReportsFilters, ReportsSortBy } from '@models/interfaces';
import { getGenericSortableColumn, renderDateValue } from './common';

export const getReportColumns = (
  reportKey: ReportKey,
  filters: ReportsFilters,
): ColumnsType<Record<string, unknown>> => {
  switch (reportKey) {
    case ReportKey.DatesAtAGlance:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'taskName',
          'Milestone',
          ReportsSortBy.TaskName,
          filters,
        ),
        { dataIndex: 'paceTaskID', title: 'PACE Task ID' },
        { dataIndex: 'paceTaskScreensDisplay', title: 'PACE Task Module(s)' },
        getGenericSortableColumn(
          'forecastedDate',
          'Forecasted Date',
          ReportsSortBy.ForecastDate,
          filters,
          renderDateValue,
        ),
        {
          dataIndex: 'PACEForecastedDate',
          title: 'PACE Forecasted Date',
          render: renderDateValue,
        },
        getGenericSortableColumn(
          'actualDate',
          'Actual Date',
          ReportsSortBy.ActualDate,
          filters,
          renderDateValue,
        ),
        {
          dataIndex: 'PACEActualDate',
          title: 'PACE Actual Date',
          render: renderDateValue,
        },
      ];
    case ReportKey.NewClosedProjects:
      return [
        getGenericSortableColumn(
          'period',
          'Period',
          ReportsSortBy.Period,
          filters,
        ),
        getGenericSortableColumn(
          'newCount',
          'New',
          ReportsSortBy.NewCount,
          filters,
        ),
        getGenericSortableColumn(
          'closedCount',
          'Closed',
          ReportsSortBy.ClosedCount,
          filters,
        ),
        { dataIndex: 'netChange', title: 'Net Change' },
      ];
    case ReportKey.ProjectDuration:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'projectType',
          'Project Type',
          ReportsSortBy.ProjectType,
          filters,
        ),
        {
          dataIndex: 'startDate',
          title: 'Start Date',
          render: renderDateValue,
        },
        {
          dataIndex: 'endDate',
          title: 'Site Acq Complete Actual',
          render: renderDateValue,
        },
        getGenericSortableColumn(
          'totalProjectDays',
          'Total Project Days',
          ReportsSortBy.TotalProjectDays,
          filters,
        ),
        getGenericSortableColumn(
          'pausedDays',
          'Total Paused Days',
          ReportsSortBy.PausedDays,
          filters,
        ),
        getGenericSortableColumn(
          'providenceDays',
          'Total Providence Days',
          ReportsSortBy.ProvidenceDays,
          filters,
        ),
      ];
    case ReportKey.StructuralPassFail:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'projectType',
          'Project Type',
          ReportsSortBy.ProjectType,
          filters,
        ),
        getGenericSortableColumn(
          'progressStatus',
          'Progress Status',
          ReportsSortBy.ProgressStatus,
          filters,
        ),
        getGenericSortableColumn(
          'structuralResult',
          'Structural Result',
          ReportsSortBy.StructuralResult,
          filters,
        ),
      ];
    case ReportKey.OverdueTasks:
    default:
      return [];
  }
};

export const getGenericReportRowKey = (record: Store): string =>
  [record.projectId, record.projectBundleID, record.paceTaskId, record.period]
    .filter(Boolean)
    .join('-');
